import { Group, Skeleton, Stack } from '@mantine/core';
import React from 'react';
import './styles.scss';

const LoaderLeaderWisdom = () => {
  return (
    <Group
      align="center"
      gap={24}
      bg="#fff"
      className="container-leader-wisdom-section__item"
    >
      <Skeleton width={200} height={200} />

      <Stack gap={12}>
        <Stack gap={5}>
          <Skeleton width={100} height={20} />
          <Skeleton width={200} height={16} />
        </Stack>

        <Skeleton height={20} />
      </Stack>
    </Group>
  );
};

export default LoaderLeaderWisdom;
